import { useSelector } from 'react-redux';

const useAuth = () => {
  const authData = useSelector((state) => state.auth.data);

  return authData;
};

export default useAuth;
